/*
 * Sandlight – "Fly to Cart" auf Kollektionsseiten (06.10.2026)
 *
 * Klick auf den runden Warenkorb-Button einer Produktkarte:
 *   - Produkt wird wie bisher vom Theme in den Warenkorb gelegt (keine eigene Warenkorb-Logik)
 *   - statt das Warenkorb-Popup zu öffnen, fliegt das Produktbild zum Warenkorb-Symbol
 *   - kurzer Hinweis unten ("In den Warenkorb gelegt · Ansehen")
 *
 * Alles andere (Warenkorb-Symbol, Upsell im Warenkorb, Produktseite, Quick View) bleibt unverändert.
 * Nur transform/opacity werden animiert (GPU), keine Scroll-Listener, ein einziger Klick-Listener.
 */
(function () {
  'use strict';
  if (window.__slFlyToCart) return;
  window.__slFlyToCart = true;

  var MAX_WAIT_MS = 8000; // so lange darf das Hinzufügen dauern, danach normales Verhalten
  var queue = [];         // offene Klicks auf Karten-Buttons (mehrere schnelle Klicks möglich)
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var origOpenCart = null;
  var toastEl = null;
  var toastTimer = null;

  function now() { return Date.now(); }

  (function injectStyles() {
    var css =
      '.sl-fly-img{position:fixed;z-index:2147483000;pointer-events:none;object-fit:cover;' +
        'border-radius:50%;box-shadow:0 8px 24px rgba(0,0,0,.25);will-change:transform,opacity;margin:0}' +
      '.sl-atc-toast{position:fixed;left:50%;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:60;' +
        'display:flex;align-items:center;gap:10px;max-width:calc(100vw - 32px);padding:10px 10px 10px 16px;' +
        'background:#111;color:#fff;border-radius:9999px;box-shadow:0 8px 24px rgba(0,0,0,.25);' +
        'font-size:15px;line-height:1.2;opacity:0;transform:translate(-50%,20px);pointer-events:none;' +
        'transition:opacity .25s ease,transform .25s ease}' +
      '.sl-atc-toast.is-visible{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
      '.sl-atc-toast__check{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;' +
        'border-radius:50%;background:#2e7d32;font-size:13px;flex:none}' +
      '.sl-atc-toast__text{white-space:nowrap}' +
      '.sl-atc-toast__btn{background:#fff;color:#111;border:0;border-radius:9999px;padding:8px 14px;' +
        'font-weight:700;font-size:14px;cursor:pointer;flex:none}' +
      '@media (prefers-reduced-motion: reduce){.sl-atc-toast{transition:none}}';
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
  })();

  function cardAddButton(target) {
    var btn = target && target.closest ? target.closest('button[name="add"]') : null;
    if (!btn) return null;
    if (btn.closest('#CartDrawer')) return null;           // Upsell im Warenkorb: Popup bleibt offen
    if (!btn.closest('.card-product')) return null;         // nur Produktkarten
    if (!btn.closest('[x-data="xProductCart"]')) return null;
    return btn;
  }

  function cardImage(btn) {
    var card = btn.closest('.card-product');
    if (!card) return null;
    return card.querySelector('img.preview-img') || card.querySelector('img');
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight &&
      r.right > 0 && r.left < window.innerWidth;
  }

  function cartTarget() {
    // Zuerst der schwebende Button (Handy), danach das Warenkorb-Symbol im Kopfbereich
    var fc = document.getElementById('sl-float-cart');
    if (visible(fc)) return fc;
    var list = document.querySelectorAll('#cart-icon-bubble, #cart-icon, [id^="cart-icon-bubble"]');
    for (var i = 0; i < list.length; i++) {
      if (visible(list[i])) return list[i];
    }
    return null;
  }

  function bump() {
    var t = cartTarget();
    if (!t || !t.animate || reduceMotion) return;
    t.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }],
      { duration: 420, easing: 'cubic-bezier(.3,1.6,.6,1)' }
    );
  }

  var srEl = null;
  function announce(text) {
    if (!srEl) {
      srEl = document.createElement('div');
      srEl.setAttribute('role', 'status');
      srEl.setAttribute('aria-live', 'polite');
      srEl.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0;';
      document.body.appendChild(srEl);
    }
    srEl.textContent = '';
    setTimeout(function () { srEl.textContent = text; }, 50);
  }

  function showToast() {
    // Handy: der schwebende Warenkorb-Button (hüpft + Zahl) ist Rückmeldung genug,
    // ein Hinweis würde die nächsten Produkt-Buttons verdecken.
    var fcv = document.getElementById('sl-float-cart');
    if (fcv && visible(fcv)) {
      announce('In den Warenkorb gelegt');
      return;
    }
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sl-atc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<span class="sl-atc-toast__check" aria-hidden="true">✓</span>' +
        '<span class="sl-atc-toast__text">In den Warenkorb gelegt</span>' +
        '<button type="button" class="sl-atc-toast__btn">Ansehen</button>';
      toastEl.querySelector('button').addEventListener('click', function () {
        hideToast();
        var store = window.Alpine && Alpine.store('xMiniCart');
        if (store && store.openCart) store.openCart();
      });
      document.body.appendChild(toastEl);
    }
    // Neu starten, falls schon sichtbar
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 3000);
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function fly(img) {
    var t = cartTarget();
    var tr = t ? t.getBoundingClientRect() : { left: window.innerWidth - 44, top: 12, width: 28, height: 28 };

    if (!img || reduceMotion || !visible(img) || !document.body.animate) {
      bump();
      showToast();
      return;
    }

    var r = img.getBoundingClientRect();
    var size = Math.round(Math.min(r.width, r.height, 140));
    var startX = r.left + r.width / 2 - size / 2;
    var startY = r.top + r.height / 2 - size / 2;
    var dx = (tr.left + tr.width / 2) - (startX + size / 2);
    var dy = (tr.top + tr.height / 2) - (startY + size / 2);

    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.className = 'sl-fly-img';
    clone.style.left = startX + 'px';
    clone.style.top = startY + 'px';
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    document.body.appendChild(clone);

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      bump();
    }

    var anim = clone.animate(
      [
        { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.45) + 'px, ' + (dy * 0.45 - 80) + 'px) scale(0.55)', opacity: 1, offset: 0.5 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)', opacity: 0.6 }
      ],
      { duration: 800, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' }
    );
    anim.onfinish = finish;
    anim.oncancel = finish;
    setTimeout(finish, 1500); // Sicherheitsnetz
    showToast();
  }

  function takePending() {
    var limit = now() - MAX_WAIT_MS;
    while (queue.length && queue[0].t < limit) queue.shift();
    return queue.shift() || null;
  }

  function patchStore() {
    var store = window.Alpine && Alpine.store && Alpine.store('xMiniCart');
    if (!store || typeof store.openCart !== 'function' || store.__slFlyPatched) return;
    origOpenCart = store.openCart;
    store.openCart = function () {
      var pending = takePending();
      if (pending) {
        fly(pending.img);
        return;
      }
      hideToast();
      return origOpenCart.apply(this, arguments);
    };
    store.__slFlyPatched = true;
  }

  // Ein Listener in der Capture-Phase – läuft vor den Theme-Handlern.
  document.addEventListener('click', function (e) {
    var btn = cardAddButton(e.target);
    if (btn) {
      patchStore();
      queue.push({ img: cardImage(btn), t: now() });
    } else {
      // Jeder andere Klick (Warenkorb-Symbol, "Ansehen" …) öffnet den Warenkorb ganz normal
      queue.length = 0;
    }
  }, true);

  document.addEventListener('alpine:initialized', patchStore);
})();
